import { darkTheme } from "@styles/themes";
import styled, { css } from "styled-components";
import { windowWidth } from "@styles/global";

interface LogoContainerProps {
  $horizontal?: boolean;
}

const horizontalStyles = css`
  flex-direction: row;
  width: auto;
  height: auto;
  gap: 12px;

  & > :first-child {
    width: auto;
  }

  .logoIconSVG svg {
    width: 44px;
    height: auto;
  }
  .logoNameSVG {
    margin-top: 0;

    svg {
      width: auto;
      height: 36px;
    }
  }

  @media ( max-width: ${windowWidth.tablet} ) {
    gap: 10px;

    .logoIconSVG svg {
      width: 38px;
    }
    .logoNameSVG svg {
      height: 30px;
    }
  }

  @media ( max-width: ${windowWidth.mobile.large} ) {
    gap: 8px;

    .logoIconSVG svg {
      width: 32px;
    }
    .logoNameSVG svg {
      height: 24px;
    }
  }

  @media ( max-width: ${windowWidth.mobile.small} ) {
    .logoIconSVG svg {
      width: 28px;
    }
    .logoNameSVG svg {
      height: 20px;
    }
  }
`;

const LogoContainer = styled.div<LogoContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  & > :first-child {
    width: 60%;
  }

  svg {
    width: 100%;

    * {
      fill: ${({ theme }) => theme === darkTheme && theme.colors.navBarIcons};
    }
  }

  .logoIconSVG {
    text-align: center;

    svg {
      width: 80px;
    }
  }
  .logoNameSVG {
    margin-top: 10px;

    svg {
      width: 250px;
    }
  }

  ${({ $horizontal }) => $horizontal && horizontalStyles}
`;

export default LogoContainer;
